import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { translateAnimalCategory, translateAnimalCategoryAge, translateAnimalCategoryDescription } from "../../../../i18n/translateAnimalCategory";
import { getLocale } from "../../../../i18n";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";

interface InfoAnimalSellProps {
  task: ITaskAnimalResolver | undefined;
}


export default function InfoAnimalSell(task: InfoAnimalSellProps) {
  const { t } = useTranslation();
  const [taskSell, setTaskSell] = useState<ITaskAnimalResolver>();
  useEffect(() => {
    setTaskSell(task.task)
  }, []);

  const categories = taskSell?.details.flatMap(detail => detail.categories) ?? [];
  const categoriesWithWeight = categories.filter(category =>
    Number(category.quantity) > 0 && Number.isFinite(category.weight?.value)
  );
  const totalAnimals = categoriesWithWeight.reduce((sum, category) => sum + Number(category.quantity), 0);
  const averageLiveWeight = totalAnimals > 0
    ? Math.round(categoriesWithWeight.reduce((sum, category) =>
      sum + category.weight.value * Number(category.quantity), 0) / totalAnimals * 100) / 100
    : undefined;

  return (
    <>
      <div >
        <span><Trans i18nKey="taskDetails.onArea" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AreaIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskSell?.area_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div >
        <span><Trans i18nKey="taskDetails.onBatch" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AnimalsIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskSell?.batch_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={t("taskMonitoring.details.liveOrSlaughter")} pointed />
        <ButtonPressed
          onlyResult
          optionSelected={1}
          value={1}
          text={t(taskSell?.task_update_type === "Venda" ? "taskMonitoring.details.live" : "taskMonitoring.details.slaughter")}
        />
      </div>

      {taskSell?.details.flatMap((detail, detailIndex) =>
        detail.categories.map((category, categoryIndex) => (
          <div key={`${detailIndex}-${categoryIndex}`} className="animalSaleCategory">
            <div className="animalSaleCategory__title">{translateAnimalCategoryDescription(category.category_description)}</div>

            {category.weight?.value != null && (
              <div className="animalSaleCategory__weight">
                {new Intl.NumberFormat(getLocale(), { maximumFractionDigits: 20 }).format(category.weight.value)} {category.weight.unit}
              </div>
            )}
            <CounterInputV2 name={`info-animal-sell-qty-${detailIndex}-${categoryIndex}`} value={Number(category.quantity ?? 0)} disabled />
          </div>
        ))
      )}
      {averageLiveWeight !== undefined && (
        <CounterInputV2
          name="info-animal-sell-average-live-weight"
          label={t("taskDetails.animalSale.averageLiveWeight")}
          value={averageLiveWeight}
          suffix={categoriesWithWeight[0].weight.unit}
          allowDecimal
          disabled
        />
      )}
    </>
  )
}
